import React from "react";
import resetIcon from "../../../../img/icons/Icon-left.svg";
import localization from '../../../../data/config';
import "./style.css";

/**
 * @name Reset
 * @function
 * @description Displays Reset Column
 * @returns {JSX}
 * @param {*} props
 */
const Reset = (props) => {
  // Function to reset the Column Filter
  const handleReset = () => {
    props.onClick();
  };

  return (
    <div className="reset-column" onClick={props.onClick ? handleReset : null} tabIndex="0" role="button" aria-label={localization.resetColumn}>
      <img src={resetIcon} className="reset-column__reset-icon" alt="Reset Icon" />
      <p>{localization.resetColumn}</p>
    </div>
  );
};

export default Reset;
